<template>
  <div class="modal">
    <transition
      name="modal-fade"
      @after-leave="hideModal()"
    >
      <div
        class="modal-dialog"
        :class="[`modal-${size}`]"
        v-if="show"
      >
        <div class="modal-content">
          <div
            class="pr-4 pt-4 pl-4 pb-0 modal-header"
            v-if="hasTitle"
          >
            <h5 class="modal-title">
              <slot name="title"></slot>
            </h5>

            <button
              v-if="closable"
              type="button"
              class="btn btn-secondary btn-sm"
              data-dismiss="modal"
              aria-label="Close"
              @click="show = false"
            >×</button>
          </div>
          <div
            class="modal-body"
            :class="{'p-4': bodyPadding, 'p-0': !bodyPadding}"
            v-if="hasBody"
          >
            <slot name="body"></slot>
          </div>
          <div
            class="modal-footer"
            v-if="hasFooter"
          >
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    bodyPadding: {
      type: Boolean,
      default() {
        return true;
      },
    },
    canClose: {
      type: Boolean,
      default() {
        return true;
      },
    },
    closable: {
      type: Boolean,
      default() {
        return true;
      },
    },
    coloredHeader: {
      type: Boolean,
      default() {
        return true;
      },
    },
    size: {
      type: String,
      default() {
        return 'lg';
      },
    },
    styleType: {
      type: String,
      default() {
        return 'primary';
      },
    },
  },
  data() {
    return {
      show: false,
      dialogVisible: false,
      backgroundClassName: 'modal-background',
    };
  },
  computed: {
    hasTitle() {
      return (this.$slots.title || []).length > 0;
    },
    hasBody() {
      return (this.$slots.body || []).length > 0;
    },
    hasFooter() {
      return (this.$slots.footer || []).length > 0;
    },
  },
  methods: {
    hideModal() {
      this.$emit('hide-modal');
    },
  },
  created() {
    setTimeout(() => {
      this.show = true;
    }, 1);
  },
};
</script>

<style scoped>
.modal {
  display: block;
  background: rgba(0, 0, 0, 0.2);
}

.modal {
  overflow-y: auto;
}

.modal-body {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.modal-header {
  align-items: flex-start;
}

@media screen and (max-width: 767px) {
  /* Small screens */
  .modal {
    background: rgba(0, 0, 0, 0);
  }

  .modal-content {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    max-width: unset;
    width: 100%;
    margin: 0;
    border-radius: 0;
  }

  .modal-body {
    overflow: auto;
    max-height: unset;
  }
}
</style>
